/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.TagManager.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query'
import type {
  AwsPolicyDetailQueryResult,
  DeleteMapContractsDeleteAgreementDocumentParams,
  DeleteMapContractsDeleteMapContractParams,
  DeleteTagAutomationRemoveTagAutomationRuleParams,
  DeleteTagManagerRemoveDraftPolicyGroupParams,
  DeleteTagManagerRemoveRestrictedTagParams,
  DeleteTagManagerRemoveTagPolicyParams,
  DeleteVariantGroupDeleteVariantGroupParams,
  DeleteVariantGroupDeleteVariantParams,
  GetMapContractsDownloadAgreementDocumentParams,
  GetMapContractsEnsureRuleGroupParams,
  GetMapContractsGetMapContractByIdParams,
  GetMapContractsGetMapContractMetricsParams,
  GetMapContractsGetMapEligibilityQueriesParams,
  GetRestrictedTagsGetGroupRestrictedTagsParams,
  GetRestrictedTagsGetRestrictedTagParams,
  GetTagAutomationGetActiveTagAutomationRulesParams,
  GetTagAutomationGetTagAutomationRuleDetailsParams,
  GetTagAutomationGetTagAutomationRuleParams,
  GetTagAutomationGetTagAutomationRulesParams,
  GetTagAutomationGetTestModeTagAutomationRulesParams,
  GetTagAutomationRuleGroupGetGroupsParams,
  GetTagAutomationRuleGroupGetRuleGroupParams,
  GetTagHealthGetTagHealthMetricsForCurrentMonthParams,
  GetTagManagerGetAWSTagPoliciesParams,
  GetTagManagerGetDraftPoliciesParams,
  GetTagManagerGetRestrictedTagParams,
  GetTagManagerGetRestrictedTagsParams,
  GetTagManagerGetTagPoliciesParams,
  GetTagManagerGetTagPolicyParams,
  GetVariantGroupGetVariantGroupParams,
  GetVariantGroupGetVariantGroupsParams,
  GetVariantGroupGetVariantParams,
  GetVariantGroupGetVariantsForGroupParams,
  GetVariationDetectorCalculateLevensteinDistanceParams,
  MapContract,
  MapContractBase,
  MapContractDailySnapShotQueryResult,
  MapContractReadResponse,
  MapContractRollup,
  MapContractStatsQuery,
  MapContractStatus,
  MapManagerStat,
  MapMigratedTagFixResult,
  MapQueryBundle,
  MapSupportedService,
  ObjectQueryResult,
  PolicyGrouping,
  PostMapContractsEnsureMapCostAllocationTagParams,
  PostMapContractsExtractDataFromDocumentBody,
  PostMapContractsGenerateDummySnapshotDataForCompanyContractParams,
  PostMapContractsGetMapContractRollupParams,
  PostMapContractsUploadAgreementDocumentBody,
  PostMapContractsUploadAgreementDocumentParams,
  PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync200One,
  PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync200Three,
  PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync200Two,
  PostTagAutomationRuleGroupSaveRuleGroupParams,
  PostTagHealthInsertFakeDataParams,
  PostTagHealthRecordTagComplianceScoreParams,
  PostTagManagerImportAWSPoliciesParams,
  PostVariantGroupConsolidateVariantGroupParams,
  PostVariantGroupGetAllTagsForAutocompleteParams,
  Query,
  RestrictedTag,
  StringSearchIndexChange,
  TagAutomationRule,
  TagAutomationRuleDetails,
  TagAutomationRuleGroup,
  TagHealthMetric,
  TagHealthMetricQueryResult,
  TagHistoryItem,
  TagPolicy,
  Variant,
  VariantGroup,
  VariantResource
} from './TagManager/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const postMapContractsCreateMapContract = (
    mapContractBase: MapContractBase,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContract>(
      {url: `/MapContracts/CreateMapContract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mapContractBase
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsCreateMapContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsCreateMapContract>>, TError,{data: MapContractBase}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsCreateMapContract>>, TError,{data: MapContractBase}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsCreateMapContract>>, {data: MapContractBase}> = (props) => {
          const {data} = props ?? {};

          return  postMapContractsCreateMapContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsCreateMapContractMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsCreateMapContract>>>
    export type PostMapContractsCreateMapContractMutationBody = MapContractBase
    export type PostMapContractsCreateMapContractMutationError = unknown

    export const usePostMapContractsCreateMapContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsCreateMapContract>>, TError,{data: MapContractBase}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsCreateMapContract>>,
        TError,
        {data: MapContractBase},
        TContext
      > => {

      const mutationOptions = getPostMapContractsCreateMapContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMapContractsUpdateMapContract = (
    mapContract: MapContract,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContract>(
      {url: `/MapContracts/UpdateMapContract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mapContract
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsUpdateMapContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsUpdateMapContract>>, TError,{data: MapContract}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsUpdateMapContract>>, TError,{data: MapContract}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsUpdateMapContract>>, {data: MapContract}> = (props) => {
          const {data} = props ?? {};

          return  postMapContractsUpdateMapContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsUpdateMapContractMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsUpdateMapContract>>>
    export type PostMapContractsUpdateMapContractMutationBody = MapContract
    export type PostMapContractsUpdateMapContractMutationError = unknown

    export const usePostMapContractsUpdateMapContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsUpdateMapContract>>, TError,{data: MapContract}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsUpdateMapContract>>,
        TError,
        {data: MapContract},
        TContext
      > => {

      const mutationOptions = getPostMapContractsUpdateMapContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteMapContractsDeleteMapContract = (
    params?: DeleteMapContractsDeleteMapContractParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/MapContracts/DeleteMapContract`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteMapContractsDeleteMapContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMapContractsDeleteMapContract>>, TError,{params?: DeleteMapContractsDeleteMapContractParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMapContractsDeleteMapContract>>, TError,{params?: DeleteMapContractsDeleteMapContractParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMapContractsDeleteMapContract>>, {params?: DeleteMapContractsDeleteMapContractParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteMapContractsDeleteMapContract(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMapContractsDeleteMapContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMapContractsDeleteMapContract>>>
    
    export type DeleteMapContractsDeleteMapContractMutationError = unknown

    export const useDeleteMapContractsDeleteMapContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMapContractsDeleteMapContract>>, TError,{params?: DeleteMapContractsDeleteMapContractParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteMapContractsDeleteMapContract>>,
        TError,
        {params?: DeleteMapContractsDeleteMapContractParams},
        TContext
      > => {

      const mutationOptions = getDeleteMapContractsDeleteMapContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMapContractsGetMapContractById = (
    params?: GetMapContractsGetMapContractByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MapContract>(
      {url: `/MapContracts/GetMapContractById`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetMapContractsGetMapContractByIdQueryKey = (params?: GetMapContractsGetMapContractByIdParams,) => {
    return [`/MapContracts/GetMapContractById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMapContractsGetMapContractByIdQueryOptions = <TData = Awaited<ReturnType<typeof getMapContractsGetMapContractById>>, TError = unknown>(params?: GetMapContractsGetMapContractByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContractById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMapContractsGetMapContractByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMapContractsGetMapContractById>>> = ({ signal }) => getMapContractsGetMapContractById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContractById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMapContractsGetMapContractByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMapContractsGetMapContractById>>>
export type GetMapContractsGetMapContractByIdQueryError = unknown

export const useGetMapContractsGetMapContractById = <TData = Awaited<ReturnType<typeof getMapContractsGetMapContractById>>, TError = unknown>(
 params?: GetMapContractsGetMapContractByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContractById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMapContractsGetMapContractByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMapContractsGetMapContracts = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MapContract[]>(
      {url: `/MapContracts/GetMapContracts`, method: 'GET', signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetMapContractsGetMapContractsQueryKey = () => {
    return [`/MapContracts/GetMapContracts`] as const;
    }

    
export const getGetMapContractsGetMapContractsQueryOptions = <TData = Awaited<ReturnType<typeof getMapContractsGetMapContracts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContracts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMapContractsGetMapContractsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMapContractsGetMapContracts>>> = ({ signal }) => getMapContractsGetMapContracts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContracts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMapContractsGetMapContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getMapContractsGetMapContracts>>>
export type GetMapContractsGetMapContractsQueryError = unknown

export const useGetMapContractsGetMapContracts = <TData = Awaited<ReturnType<typeof getMapContractsGetMapContracts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContracts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMapContractsGetMapContractsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMapContractsUploadAgreementDocument = (
    postMapContractsUploadAgreementDocumentBody: PostMapContractsUploadAgreementDocumentBody,
    params?: PostMapContractsUploadAgreementDocumentParams,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postMapContractsUploadAgreementDocumentBody.file !== undefined) {
 formData.append('file', postMapContractsUploadAgreementDocumentBody.file)
 }

      return request<MapContract>(
      {url: `/MapContracts/UploadAgreementDocument`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData,
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsUploadAgreementDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsUploadAgreementDocument>>, TError,{data: PostMapContractsUploadAgreementDocumentBody;params?: PostMapContractsUploadAgreementDocumentParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsUploadAgreementDocument>>, TError,{data: PostMapContractsUploadAgreementDocumentBody;params?: PostMapContractsUploadAgreementDocumentParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsUploadAgreementDocument>>, {data: PostMapContractsUploadAgreementDocumentBody;params?: PostMapContractsUploadAgreementDocumentParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postMapContractsUploadAgreementDocument(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsUploadAgreementDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsUploadAgreementDocument>>>
    export type PostMapContractsUploadAgreementDocumentMutationBody = PostMapContractsUploadAgreementDocumentBody
    export type PostMapContractsUploadAgreementDocumentMutationError = unknown

    export const usePostMapContractsUploadAgreementDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsUploadAgreementDocument>>, TError,{data: PostMapContractsUploadAgreementDocumentBody;params?: PostMapContractsUploadAgreementDocumentParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsUploadAgreementDocument>>,
        TError,
        {data: PostMapContractsUploadAgreementDocumentBody;params?: PostMapContractsUploadAgreementDocumentParams},
        TContext
      > => {

      const mutationOptions = getPostMapContractsUploadAgreementDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMapContractsGenerateDummySnapshotDataForCompanyContract = (
    params?: PostMapContractsGenerateDummySnapshotDataForCompanyContractParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/MapContracts/GenerateDummySnapshotDataForCompanyContract`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsGenerateDummySnapshotDataForCompanyContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGenerateDummySnapshotDataForCompanyContract>>, TError,{params?: PostMapContractsGenerateDummySnapshotDataForCompanyContractParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGenerateDummySnapshotDataForCompanyContract>>, TError,{params?: PostMapContractsGenerateDummySnapshotDataForCompanyContractParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsGenerateDummySnapshotDataForCompanyContract>>, {params?: PostMapContractsGenerateDummySnapshotDataForCompanyContractParams}> = (props) => {
          const {params} = props ?? {};

          return  postMapContractsGenerateDummySnapshotDataForCompanyContract(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsGenerateDummySnapshotDataForCompanyContractMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsGenerateDummySnapshotDataForCompanyContract>>>
    
    export type PostMapContractsGenerateDummySnapshotDataForCompanyContractMutationError = unknown

    export const usePostMapContractsGenerateDummySnapshotDataForCompanyContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGenerateDummySnapshotDataForCompanyContract>>, TError,{params?: PostMapContractsGenerateDummySnapshotDataForCompanyContractParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsGenerateDummySnapshotDataForCompanyContract>>,
        TError,
        {params?: PostMapContractsGenerateDummySnapshotDataForCompanyContractParams},
        TContext
      > => {

      const mutationOptions = getPostMapContractsGenerateDummySnapshotDataForCompanyContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteMapContractsDeleteAgreementDocument = (
    params?: DeleteMapContractsDeleteAgreementDocumentParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContract>(
      {url: `/MapContracts/DeleteAgreementDocument`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteMapContractsDeleteAgreementDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMapContractsDeleteAgreementDocument>>, TError,{params?: DeleteMapContractsDeleteAgreementDocumentParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMapContractsDeleteAgreementDocument>>, TError,{params?: DeleteMapContractsDeleteAgreementDocumentParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMapContractsDeleteAgreementDocument>>, {params?: DeleteMapContractsDeleteAgreementDocumentParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteMapContractsDeleteAgreementDocument(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMapContractsDeleteAgreementDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMapContractsDeleteAgreementDocument>>>
    
    export type DeleteMapContractsDeleteAgreementDocumentMutationError = unknown

    export const useDeleteMapContractsDeleteAgreementDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMapContractsDeleteAgreementDocument>>, TError,{params?: DeleteMapContractsDeleteAgreementDocumentParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteMapContractsDeleteAgreementDocument>>,
        TError,
        {params?: DeleteMapContractsDeleteAgreementDocumentParams},
        TContext
      > => {

      const mutationOptions = getDeleteMapContractsDeleteAgreementDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMapContractsDownloadAgreementDocument = (
    params?: GetMapContractsDownloadAgreementDocumentParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/MapContracts/DownloadAgreementDocument`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetMapContractsDownloadAgreementDocumentQueryKey = (params?: GetMapContractsDownloadAgreementDocumentParams,) => {
    return [`/MapContracts/DownloadAgreementDocument`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMapContractsDownloadAgreementDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>, TError = unknown>(params?: GetMapContractsDownloadAgreementDocumentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMapContractsDownloadAgreementDocumentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>> = ({ signal }) => getMapContractsDownloadAgreementDocument(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMapContractsDownloadAgreementDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>>
export type GetMapContractsDownloadAgreementDocumentQueryError = unknown

export const useGetMapContractsDownloadAgreementDocument = <TData = Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>, TError = unknown>(
 params?: GetMapContractsDownloadAgreementDocumentParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsDownloadAgreementDocument>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMapContractsDownloadAgreementDocumentQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMapContractsValidateMapContract = (
    postMapContractsValidateMapContractBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContractStatus[]>(
      {url: `/MapContracts/ValidateMapContract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMapContractsValidateMapContractBody
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsValidateMapContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsValidateMapContract>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsValidateMapContract>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsValidateMapContract>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postMapContractsValidateMapContract(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsValidateMapContractMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsValidateMapContract>>>
    export type PostMapContractsValidateMapContractMutationBody = number[]
    export type PostMapContractsValidateMapContractMutationError = unknown

    export const usePostMapContractsValidateMapContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsValidateMapContract>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsValidateMapContract>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostMapContractsValidateMapContractMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMapContractsEnsureMapCostAllocationTag = (
    params?: PostMapContractsEnsureMapCostAllocationTagParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapMigratedTagFixResult>(
      {url: `/MapContracts/EnsureMapCostAllocationTag`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsEnsureMapCostAllocationTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsEnsureMapCostAllocationTag>>, TError,{params?: PostMapContractsEnsureMapCostAllocationTagParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsEnsureMapCostAllocationTag>>, TError,{params?: PostMapContractsEnsureMapCostAllocationTagParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsEnsureMapCostAllocationTag>>, {params?: PostMapContractsEnsureMapCostAllocationTagParams}> = (props) => {
          const {params} = props ?? {};

          return  postMapContractsEnsureMapCostAllocationTag(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsEnsureMapCostAllocationTagMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsEnsureMapCostAllocationTag>>>
    
    export type PostMapContractsEnsureMapCostAllocationTagMutationError = unknown

    export const usePostMapContractsEnsureMapCostAllocationTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsEnsureMapCostAllocationTag>>, TError,{params?: PostMapContractsEnsureMapCostAllocationTagParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsEnsureMapCostAllocationTag>>,
        TError,
        {params?: PostMapContractsEnsureMapCostAllocationTagParams},
        TContext
      > => {

      const mutationOptions = getPostMapContractsEnsureMapCostAllocationTagMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMapContractsGetMapResourceTypes = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapSupportedService[]>(
      {url: `/MapContracts/GetMapResourceTypes`, method: 'POST'
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsGetMapResourceTypesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGetMapResourceTypes>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGetMapResourceTypes>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsGetMapResourceTypes>>, void> = () => {
          

          return  postMapContractsGetMapResourceTypes(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsGetMapResourceTypesMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsGetMapResourceTypes>>>
    
    export type PostMapContractsGetMapResourceTypesMutationError = unknown

    export const usePostMapContractsGetMapResourceTypes = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGetMapResourceTypes>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsGetMapResourceTypes>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMapContractsGetMapResourceTypesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMapContractsGetMapEligibilityQueries = (
    params?: GetMapContractsGetMapEligibilityQueriesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MapQueryBundle[]>(
      {url: `/MapContracts/GetMapEligibilityQueries`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetMapContractsGetMapEligibilityQueriesQueryKey = (params?: GetMapContractsGetMapEligibilityQueriesParams,) => {
    return [`/MapContracts/GetMapEligibilityQueries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMapContractsGetMapEligibilityQueriesQueryOptions = <TData = Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>, TError = unknown>(params?: GetMapContractsGetMapEligibilityQueriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMapContractsGetMapEligibilityQueriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>> = ({ signal }) => getMapContractsGetMapEligibilityQueries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMapContractsGetMapEligibilityQueriesQueryResult = NonNullable<Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>>
export type GetMapContractsGetMapEligibilityQueriesQueryError = unknown

export const useGetMapContractsGetMapEligibilityQueries = <TData = Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>, TError = unknown>(
 params?: GetMapContractsGetMapEligibilityQueriesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapEligibilityQueries>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMapContractsGetMapEligibilityQueriesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMapContractsEnsureRuleGroup = (
    params?: GetMapContractsEnsureRuleGroupParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRuleGroup>(
      {url: `/MapContracts/EnsureRuleGroup`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetMapContractsEnsureRuleGroupQueryKey = (params?: GetMapContractsEnsureRuleGroupParams,) => {
    return [`/MapContracts/EnsureRuleGroup`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMapContractsEnsureRuleGroupQueryOptions = <TData = Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>, TError = unknown>(params?: GetMapContractsEnsureRuleGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMapContractsEnsureRuleGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>> = ({ signal }) => getMapContractsEnsureRuleGroup(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMapContractsEnsureRuleGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>>
export type GetMapContractsEnsureRuleGroupQueryError = unknown

export const useGetMapContractsEnsureRuleGroup = <TData = Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>, TError = unknown>(
 params?: GetMapContractsEnsureRuleGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsEnsureRuleGroup>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMapContractsEnsureRuleGroupQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMapContractsExtractDataFromDocument = (
    postMapContractsExtractDataFromDocumentBody: PostMapContractsExtractDataFromDocumentBody,
 options?: SecondParameter<typeof request>,) => {
      
      const formData = new FormData();
if(postMapContractsExtractDataFromDocumentBody.file !== undefined) {
 formData.append('file', postMapContractsExtractDataFromDocumentBody.file)
 }

      return request<MapContractReadResponse>(
      {url: `/MapContracts/ExtractDataFromDocument`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsExtractDataFromDocumentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsExtractDataFromDocument>>, TError,{data: PostMapContractsExtractDataFromDocumentBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsExtractDataFromDocument>>, TError,{data: PostMapContractsExtractDataFromDocumentBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsExtractDataFromDocument>>, {data: PostMapContractsExtractDataFromDocumentBody}> = (props) => {
          const {data} = props ?? {};

          return  postMapContractsExtractDataFromDocument(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsExtractDataFromDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsExtractDataFromDocument>>>
    export type PostMapContractsExtractDataFromDocumentMutationBody = PostMapContractsExtractDataFromDocumentBody
    export type PostMapContractsExtractDataFromDocumentMutationError = unknown

    export const usePostMapContractsExtractDataFromDocument = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsExtractDataFromDocument>>, TError,{data: PostMapContractsExtractDataFromDocumentBody}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsExtractDataFromDocument>>,
        TError,
        {data: PostMapContractsExtractDataFromDocumentBody},
        TContext
      > => {

      const mutationOptions = getPostMapContractsExtractDataFromDocumentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMapContractsGetMapContractMetrics = (
    params?: GetMapContractsGetMapContractMetricsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MapManagerStat>(
      {url: `/MapContracts/GetMapContractMetrics`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetMapContractsGetMapContractMetricsQueryKey = (params?: GetMapContractsGetMapContractMetricsParams,) => {
    return [`/MapContracts/GetMapContractMetrics`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMapContractsGetMapContractMetricsQueryOptions = <TData = Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>, TError = unknown>(params?: GetMapContractsGetMapContractMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMapContractsGetMapContractMetricsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>> = ({ signal }) => getMapContractsGetMapContractMetrics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMapContractsGetMapContractMetricsQueryResult = NonNullable<Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>>
export type GetMapContractsGetMapContractMetricsQueryError = unknown

export const useGetMapContractsGetMapContractMetrics = <TData = Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>, TError = unknown>(
 params?: GetMapContractsGetMapContractMetricsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMapContractsGetMapContractMetrics>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMapContractsGetMapContractMetricsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMapContractsQueryContractStats = (
    mapContractStatsQuery: MapContractStatsQuery,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContractDailySnapShotQueryResult>(
      {url: `/MapContracts/QueryContractStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mapContractStatsQuery
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsQueryContractStatsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsQueryContractStats>>, TError,{data: MapContractStatsQuery}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsQueryContractStats>>, TError,{data: MapContractStatsQuery}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsQueryContractStats>>, {data: MapContractStatsQuery}> = (props) => {
          const {data} = props ?? {};

          return  postMapContractsQueryContractStats(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsQueryContractStatsMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsQueryContractStats>>>
    export type PostMapContractsQueryContractStatsMutationBody = MapContractStatsQuery
    export type PostMapContractsQueryContractStatsMutationError = unknown

    export const usePostMapContractsQueryContractStats = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsQueryContractStats>>, TError,{data: MapContractStatsQuery}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsQueryContractStats>>,
        TError,
        {data: MapContractStatsQuery},
        TContext
      > => {

      const mutationOptions = getPostMapContractsQueryContractStatsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMapContractsQueryMapContractStats = (
    mapContractStatsQuery: MapContractStatsQuery,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContractDailySnapShotQueryResult>(
      {url: `/MapContracts/QueryMapContractStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mapContractStatsQuery
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsQueryMapContractStatsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsQueryMapContractStats>>, TError,{data: MapContractStatsQuery}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsQueryMapContractStats>>, TError,{data: MapContractStatsQuery}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsQueryMapContractStats>>, {data: MapContractStatsQuery}> = (props) => {
          const {data} = props ?? {};

          return  postMapContractsQueryMapContractStats(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsQueryMapContractStatsMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsQueryMapContractStats>>>
    export type PostMapContractsQueryMapContractStatsMutationBody = MapContractStatsQuery
    export type PostMapContractsQueryMapContractStatsMutationError = unknown

    export const usePostMapContractsQueryMapContractStats = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsQueryMapContractStats>>, TError,{data: MapContractStatsQuery}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsQueryMapContractStats>>,
        TError,
        {data: MapContractStatsQuery},
        TContext
      > => {

      const mutationOptions = getPostMapContractsQueryMapContractStatsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postMapContractsGetMapContractRollup = (
    params?: PostMapContractsGetMapContractRollupParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MapContractRollup[]>(
      {url: `/MapContracts/GetMapContractRollup`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostMapContractsGetMapContractRollupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGetMapContractRollup>>, TError,{params?: PostMapContractsGetMapContractRollupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGetMapContractRollup>>, TError,{params?: PostMapContractsGetMapContractRollupParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMapContractsGetMapContractRollup>>, {params?: PostMapContractsGetMapContractRollupParams}> = (props) => {
          const {params} = props ?? {};

          return  postMapContractsGetMapContractRollup(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMapContractsGetMapContractRollupMutationResult = NonNullable<Awaited<ReturnType<typeof postMapContractsGetMapContractRollup>>>
    
    export type PostMapContractsGetMapContractRollupMutationError = unknown

    export const usePostMapContractsGetMapContractRollup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMapContractsGetMapContractRollup>>, TError,{params?: PostMapContractsGetMapContractRollupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMapContractsGetMapContractRollup>>,
        TError,
        {params?: PostMapContractsGetMapContractRollupParams},
        TContext
      > => {

      const mutationOptions = getPostMapContractsGetMapContractRollupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getRestrictedTagsGetRestrictedTags = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RestrictedTag[]>(
      {url: `/RestrictedTags/GetRestrictedTags`, method: 'GET', signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetRestrictedTagsGetRestrictedTagsQueryKey = () => {
    return [`/RestrictedTags/GetRestrictedTags`] as const;
    }

    
export const getGetRestrictedTagsGetRestrictedTagsQueryOptions = <TData = Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRestrictedTagsGetRestrictedTagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>> = ({ signal }) => getRestrictedTagsGetRestrictedTags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRestrictedTagsGetRestrictedTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>>
export type GetRestrictedTagsGetRestrictedTagsQueryError = unknown

export const useGetRestrictedTagsGetRestrictedTags = <TData = Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTags>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRestrictedTagsGetRestrictedTagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRestrictedTagsGetGroupRestrictedTags = (
    params?: GetRestrictedTagsGetGroupRestrictedTagsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RestrictedTag[]>(
      {url: `/RestrictedTags/GetGroupRestrictedTags`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetRestrictedTagsGetGroupRestrictedTagsQueryKey = (params?: GetRestrictedTagsGetGroupRestrictedTagsParams,) => {
    return [`/RestrictedTags/GetGroupRestrictedTags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRestrictedTagsGetGroupRestrictedTagsQueryOptions = <TData = Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>, TError = unknown>(params?: GetRestrictedTagsGetGroupRestrictedTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRestrictedTagsGetGroupRestrictedTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>> = ({ signal }) => getRestrictedTagsGetGroupRestrictedTags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRestrictedTagsGetGroupRestrictedTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>>
export type GetRestrictedTagsGetGroupRestrictedTagsQueryError = unknown

export const useGetRestrictedTagsGetGroupRestrictedTags = <TData = Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>, TError = unknown>(
 params?: GetRestrictedTagsGetGroupRestrictedTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetGroupRestrictedTags>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRestrictedTagsGetGroupRestrictedTagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRestrictedTagsGetRestrictedTag = (
    params?: GetRestrictedTagsGetRestrictedTagParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RestrictedTag>(
      {url: `/RestrictedTags/GetRestrictedTag`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetRestrictedTagsGetRestrictedTagQueryKey = (params?: GetRestrictedTagsGetRestrictedTagParams,) => {
    return [`/RestrictedTags/GetRestrictedTag`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRestrictedTagsGetRestrictedTagQueryOptions = <TData = Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>, TError = unknown>(params?: GetRestrictedTagsGetRestrictedTagParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRestrictedTagsGetRestrictedTagQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>> = ({ signal }) => getRestrictedTagsGetRestrictedTag(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRestrictedTagsGetRestrictedTagQueryResult = NonNullable<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>>
export type GetRestrictedTagsGetRestrictedTagQueryError = unknown

export const useGetRestrictedTagsGetRestrictedTag = <TData = Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>, TError = unknown>(
 params?: GetRestrictedTagsGetRestrictedTagParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRestrictedTagsGetRestrictedTag>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRestrictedTagsGetRestrictedTagQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postRestrictedTagsSaveRestrictedTag = (
    restrictedTag: RestrictedTag[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RestrictedTag[]>(
      {url: `/RestrictedTags/SaveRestrictedTag`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: restrictedTag
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostRestrictedTagsSaveRestrictedTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRestrictedTagsSaveRestrictedTag>>, TError,{data: RestrictedTag[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRestrictedTagsSaveRestrictedTag>>, TError,{data: RestrictedTag[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRestrictedTagsSaveRestrictedTag>>, {data: RestrictedTag[]}> = (props) => {
          const {data} = props ?? {};

          return  postRestrictedTagsSaveRestrictedTag(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRestrictedTagsSaveRestrictedTagMutationResult = NonNullable<Awaited<ReturnType<typeof postRestrictedTagsSaveRestrictedTag>>>
    export type PostRestrictedTagsSaveRestrictedTagMutationBody = RestrictedTag[]
    export type PostRestrictedTagsSaveRestrictedTagMutationError = unknown

    export const usePostRestrictedTagsSaveRestrictedTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRestrictedTagsSaveRestrictedTag>>, TError,{data: RestrictedTag[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRestrictedTagsSaveRestrictedTag>>,
        TError,
        {data: RestrictedTag[]},
        TContext
      > => {

      const mutationOptions = getPostRestrictedTagsSaveRestrictedTagMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagAutomationGetTagAutomationRuleDetails = (
    params?: GetTagAutomationGetTagAutomationRuleDetailsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRuleDetails>(
      {url: `/TagAutomation/GetTagAutomationRuleDetails`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationGetTagAutomationRuleDetailsQueryKey = (params?: GetTagAutomationGetTagAutomationRuleDetailsParams,) => {
    return [`/TagAutomation/GetTagAutomationRuleDetails`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationGetTagAutomationRuleDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>, TError = unknown>(params?: GetTagAutomationGetTagAutomationRuleDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationGetTagAutomationRuleDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>> = ({ signal }) => getTagAutomationGetTagAutomationRuleDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationGetTagAutomationRuleDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>>
export type GetTagAutomationGetTagAutomationRuleDetailsQueryError = unknown

export const useGetTagAutomationGetTagAutomationRuleDetails = <TData = Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>, TError = unknown>(
 params?: GetTagAutomationGetTagAutomationRuleDetailsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRuleDetails>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationGetTagAutomationRuleDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagAutomationGetTagAutomationRules = (
    params?: GetTagAutomationGetTagAutomationRulesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRule[]>(
      {url: `/TagAutomation/GetTagAutomationRules`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationGetTagAutomationRulesQueryKey = (params?: GetTagAutomationGetTagAutomationRulesParams,) => {
    return [`/TagAutomation/GetTagAutomationRules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationGetTagAutomationRulesQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>, TError = unknown>(params?: GetTagAutomationGetTagAutomationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationGetTagAutomationRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>> = ({ signal }) => getTagAutomationGetTagAutomationRules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationGetTagAutomationRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>>
export type GetTagAutomationGetTagAutomationRulesQueryError = unknown

export const useGetTagAutomationGetTagAutomationRules = <TData = Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>, TError = unknown>(
 params?: GetTagAutomationGetTagAutomationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationGetTagAutomationRulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagAutomationGetActiveTagAutomationRules = (
    params?: GetTagAutomationGetActiveTagAutomationRulesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRule[]>(
      {url: `/TagAutomation/GetActiveTagAutomationRules`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationGetActiveTagAutomationRulesQueryKey = (params?: GetTagAutomationGetActiveTagAutomationRulesParams,) => {
    return [`/TagAutomation/GetActiveTagAutomationRules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationGetActiveTagAutomationRulesQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>, TError = unknown>(params?: GetTagAutomationGetActiveTagAutomationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationGetActiveTagAutomationRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>> = ({ signal }) => getTagAutomationGetActiveTagAutomationRules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationGetActiveTagAutomationRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>>
export type GetTagAutomationGetActiveTagAutomationRulesQueryError = unknown

export const useGetTagAutomationGetActiveTagAutomationRules = <TData = Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>, TError = unknown>(
 params?: GetTagAutomationGetActiveTagAutomationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetActiveTagAutomationRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationGetActiveTagAutomationRulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync = (
    postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync200One | PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync200Two | PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync200Three>(
      {url: `/TagAutomation/GetActiveTagAutomationRulesCountForMspChildCompaniesAsync`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncBody
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncMutationResult = NonNullable<Awaited<ReturnType<typeof postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync>>>
    export type PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncMutationBody = number[]
    export type PostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncMutationError = unknown

    export const usePostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsync>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostTagAutomationGetActiveTagAutomationRulesCountForMspChildCompaniesAsyncMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagAutomationGetTestModeTagAutomationRules = (
    params?: GetTagAutomationGetTestModeTagAutomationRulesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRule[]>(
      {url: `/TagAutomation/GetTestModeTagAutomationRules`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationGetTestModeTagAutomationRulesQueryKey = (params?: GetTagAutomationGetTestModeTagAutomationRulesParams,) => {
    return [`/TagAutomation/GetTestModeTagAutomationRules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationGetTestModeTagAutomationRulesQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>, TError = unknown>(params?: GetTagAutomationGetTestModeTagAutomationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationGetTestModeTagAutomationRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>> = ({ signal }) => getTagAutomationGetTestModeTagAutomationRules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationGetTestModeTagAutomationRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>>
export type GetTagAutomationGetTestModeTagAutomationRulesQueryError = unknown

export const useGetTagAutomationGetTestModeTagAutomationRules = <TData = Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>, TError = unknown>(
 params?: GetTagAutomationGetTestModeTagAutomationRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTestModeTagAutomationRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationGetTestModeTagAutomationRulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagAutomationGetTagAutomationRule = (
    params?: GetTagAutomationGetTagAutomationRuleParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRule>(
      {url: `/TagAutomation/GetTagAutomationRule`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationGetTagAutomationRuleQueryKey = (params?: GetTagAutomationGetTagAutomationRuleParams,) => {
    return [`/TagAutomation/GetTagAutomationRule`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationGetTagAutomationRuleQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>, TError = unknown>(params?: GetTagAutomationGetTagAutomationRuleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationGetTagAutomationRuleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>> = ({ signal }) => getTagAutomationGetTagAutomationRule(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationGetTagAutomationRuleQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>>
export type GetTagAutomationGetTagAutomationRuleQueryError = unknown

export const useGetTagAutomationGetTagAutomationRule = <TData = Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>, TError = unknown>(
 params?: GetTagAutomationGetTagAutomationRuleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationGetTagAutomationRule>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationGetTagAutomationRuleQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagAutomationQueryTrace = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/TagAutomation/QueryTrace`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagAutomationQueryTraceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationQueryTrace>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationQueryTrace>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagAutomationQueryTrace>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagAutomationQueryTrace(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagAutomationQueryTraceMutationResult = NonNullable<Awaited<ReturnType<typeof postTagAutomationQueryTrace>>>
    export type PostTagAutomationQueryTraceMutationBody = Query
    export type PostTagAutomationQueryTraceMutationError = unknown

    export const usePostTagAutomationQueryTrace = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationQueryTrace>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagAutomationQueryTrace>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagAutomationQueryTraceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagAutomationQueryTraceByRule = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ObjectQueryResult>(
      {url: `/TagAutomation/QueryTraceByRule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagAutomationQueryTraceByRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationQueryTraceByRule>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationQueryTraceByRule>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagAutomationQueryTraceByRule>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagAutomationQueryTraceByRule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagAutomationQueryTraceByRuleMutationResult = NonNullable<Awaited<ReturnType<typeof postTagAutomationQueryTraceByRule>>>
    export type PostTagAutomationQueryTraceByRuleMutationBody = Query
    export type PostTagAutomationQueryTraceByRuleMutationError = unknown

    export const usePostTagAutomationQueryTraceByRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationQueryTraceByRule>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagAutomationQueryTraceByRule>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagAutomationQueryTraceByRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagAutomationCreateTagAutomationRule = (
    tagAutomationRule: TagAutomationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagAutomationRule>(
      {url: `/TagAutomation/CreateTagAutomationRule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationRule
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagAutomationCreateTagAutomationRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationCreateTagAutomationRule>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationCreateTagAutomationRule>>, TError,{data: TagAutomationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagAutomationCreateTagAutomationRule>>, {data: TagAutomationRule}> = (props) => {
          const {data} = props ?? {};

          return  postTagAutomationCreateTagAutomationRule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagAutomationCreateTagAutomationRuleMutationResult = NonNullable<Awaited<ReturnType<typeof postTagAutomationCreateTagAutomationRule>>>
    export type PostTagAutomationCreateTagAutomationRuleMutationBody = TagAutomationRule
    export type PostTagAutomationCreateTagAutomationRuleMutationError = unknown

    export const usePostTagAutomationCreateTagAutomationRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationCreateTagAutomationRule>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagAutomationCreateTagAutomationRule>>,
        TError,
        {data: TagAutomationRule},
        TContext
      > => {

      const mutationOptions = getPostTagAutomationCreateTagAutomationRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putTagAutomationSaveTagAutomationRule = (
    tagAutomationRule: TagAutomationRule,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagAutomationRule>(
      {url: `/TagAutomation/SaveTagAutomationRule`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tagAutomationRule
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutTagAutomationSaveTagAutomationRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagAutomationSaveTagAutomationRule>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putTagAutomationSaveTagAutomationRule>>, TError,{data: TagAutomationRule}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTagAutomationSaveTagAutomationRule>>, {data: TagAutomationRule}> = (props) => {
          const {data} = props ?? {};

          return  putTagAutomationSaveTagAutomationRule(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTagAutomationSaveTagAutomationRuleMutationResult = NonNullable<Awaited<ReturnType<typeof putTagAutomationSaveTagAutomationRule>>>
    export type PutTagAutomationSaveTagAutomationRuleMutationBody = TagAutomationRule
    export type PutTagAutomationSaveTagAutomationRuleMutationError = unknown

    export const usePutTagAutomationSaveTagAutomationRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagAutomationSaveTagAutomationRule>>, TError,{data: TagAutomationRule}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putTagAutomationSaveTagAutomationRule>>,
        TError,
        {data: TagAutomationRule},
        TContext
      > => {

      const mutationOptions = getPutTagAutomationSaveTagAutomationRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteTagAutomationRemoveTagAutomationRule = (
    params?: DeleteTagAutomationRemoveTagAutomationRuleParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagAutomation/RemoveTagAutomationRule`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteTagAutomationRemoveTagAutomationRuleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagAutomationRemoveTagAutomationRule>>, TError,{params?: DeleteTagAutomationRemoveTagAutomationRuleParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTagAutomationRemoveTagAutomationRule>>, TError,{params?: DeleteTagAutomationRemoveTagAutomationRuleParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTagAutomationRemoveTagAutomationRule>>, {params?: DeleteTagAutomationRemoveTagAutomationRuleParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteTagAutomationRemoveTagAutomationRule(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTagAutomationRemoveTagAutomationRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTagAutomationRemoveTagAutomationRule>>>
    
    export type DeleteTagAutomationRemoveTagAutomationRuleMutationError = unknown

    export const useDeleteTagAutomationRemoveTagAutomationRule = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagAutomationRemoveTagAutomationRule>>, TError,{params?: DeleteTagAutomationRemoveTagAutomationRuleParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteTagAutomationRemoveTagAutomationRule>>,
        TError,
        {params?: DeleteTagAutomationRemoveTagAutomationRuleParams},
        TContext
      > => {

      const mutationOptions = getDeleteTagAutomationRemoveTagAutomationRuleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagAutomationGetTotalActivityCount = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/TagAutomation/GetTotalActivityCount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagAutomationGetTotalActivityCountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationGetTotalActivityCount>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationGetTotalActivityCount>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagAutomationGetTotalActivityCount>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagAutomationGetTotalActivityCount(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagAutomationGetTotalActivityCountMutationResult = NonNullable<Awaited<ReturnType<typeof postTagAutomationGetTotalActivityCount>>>
    export type PostTagAutomationGetTotalActivityCountMutationBody = Query
    export type PostTagAutomationGetTotalActivityCountMutationError = unknown

    export const usePostTagAutomationGetTotalActivityCount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationGetTotalActivityCount>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagAutomationGetTotalActivityCount>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagAutomationGetTotalActivityCountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagAutomationRuleGroupGetRuleGroup = (
    params?: GetTagAutomationRuleGroupGetRuleGroupParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRuleGroup>(
      {url: `/TagAutomationRuleGroup/GetRuleGroup`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationRuleGroupGetRuleGroupQueryKey = (params?: GetTagAutomationRuleGroupGetRuleGroupParams,) => {
    return [`/TagAutomationRuleGroup/GetRuleGroup`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationRuleGroupGetRuleGroupQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>, TError = unknown>(params?: GetTagAutomationRuleGroupGetRuleGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationRuleGroupGetRuleGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>> = ({ signal }) => getTagAutomationRuleGroupGetRuleGroup(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationRuleGroupGetRuleGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>>
export type GetTagAutomationRuleGroupGetRuleGroupQueryError = unknown

export const useGetTagAutomationRuleGroupGetRuleGroup = <TData = Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>, TError = unknown>(
 params?: GetTagAutomationRuleGroupGetRuleGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetRuleGroup>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationRuleGroupGetRuleGroupQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagAutomationRuleGroupSaveRuleGroup = (
    postTagAutomationRuleGroupSaveRuleGroupBody: number[],
    params?: PostTagAutomationRuleGroupSaveRuleGroupParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/TagAutomationRuleGroup/SaveRuleGroup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTagAutomationRuleGroupSaveRuleGroupBody,
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagAutomationRuleGroupSaveRuleGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationRuleGroupSaveRuleGroup>>, TError,{data: number[];params?: PostTagAutomationRuleGroupSaveRuleGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationRuleGroupSaveRuleGroup>>, TError,{data: number[];params?: PostTagAutomationRuleGroupSaveRuleGroupParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagAutomationRuleGroupSaveRuleGroup>>, {data: number[];params?: PostTagAutomationRuleGroupSaveRuleGroupParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postTagAutomationRuleGroupSaveRuleGroup(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagAutomationRuleGroupSaveRuleGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postTagAutomationRuleGroupSaveRuleGroup>>>
    export type PostTagAutomationRuleGroupSaveRuleGroupMutationBody = number[]
    export type PostTagAutomationRuleGroupSaveRuleGroupMutationError = unknown

    export const usePostTagAutomationRuleGroupSaveRuleGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagAutomationRuleGroupSaveRuleGroup>>, TError,{data: number[];params?: PostTagAutomationRuleGroupSaveRuleGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagAutomationRuleGroupSaveRuleGroup>>,
        TError,
        {data: number[];params?: PostTagAutomationRuleGroupSaveRuleGroupParams},
        TContext
      > => {

      const mutationOptions = getPostTagAutomationRuleGroupSaveRuleGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagAutomationRuleGroupGetGroups = (
    params?: GetTagAutomationRuleGroupGetGroupsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagAutomationRuleGroup[]>(
      {url: `/TagAutomationRuleGroup/GetGroups`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagAutomationRuleGroupGetGroupsQueryKey = (params?: GetTagAutomationRuleGroupGetGroupsParams,) => {
    return [`/TagAutomationRuleGroup/GetGroups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagAutomationRuleGroupGetGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>, TError = unknown>(params?: GetTagAutomationRuleGroupGetGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagAutomationRuleGroupGetGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>> = ({ signal }) => getTagAutomationRuleGroupGetGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagAutomationRuleGroupGetGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>>
export type GetTagAutomationRuleGroupGetGroupsQueryError = unknown

export const useGetTagAutomationRuleGroupGetGroups = <TData = Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>, TError = unknown>(
 params?: GetTagAutomationRuleGroupGetGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagAutomationRuleGroupGetGroups>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagAutomationRuleGroupGetGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagHealthRecordTagComplianceScore = (
    params?: PostTagHealthRecordTagComplianceScoreParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagHealth/RecordTagComplianceScore`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagHealthRecordTagComplianceScoreMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthRecordTagComplianceScore>>, TError,{params?: PostTagHealthRecordTagComplianceScoreParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagHealthRecordTagComplianceScore>>, TError,{params?: PostTagHealthRecordTagComplianceScoreParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagHealthRecordTagComplianceScore>>, {params?: PostTagHealthRecordTagComplianceScoreParams}> = (props) => {
          const {params} = props ?? {};

          return  postTagHealthRecordTagComplianceScore(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagHealthRecordTagComplianceScoreMutationResult = NonNullable<Awaited<ReturnType<typeof postTagHealthRecordTagComplianceScore>>>
    
    export type PostTagHealthRecordTagComplianceScoreMutationError = unknown

    export const usePostTagHealthRecordTagComplianceScore = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthRecordTagComplianceScore>>, TError,{params?: PostTagHealthRecordTagComplianceScoreParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagHealthRecordTagComplianceScore>>,
        TError,
        {params?: PostTagHealthRecordTagComplianceScoreParams},
        TContext
      > => {

      const mutationOptions = getPostTagHealthRecordTagComplianceScoreMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagHealthGetTagHealthMetricsForCurrentMonth = (
    params?: GetTagHealthGetTagHealthMetricsForCurrentMonthParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagHealthMetric[]>(
      {url: `/TagHealth/GetTagHealthMetricsForCurrentMonth`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagHealthGetTagHealthMetricsForCurrentMonthQueryKey = (params?: GetTagHealthGetTagHealthMetricsForCurrentMonthParams,) => {
    return [`/TagHealth/GetTagHealthMetricsForCurrentMonth`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagHealthGetTagHealthMetricsForCurrentMonthQueryOptions = <TData = Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>, TError = unknown>(params?: GetTagHealthGetTagHealthMetricsForCurrentMonthParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagHealthGetTagHealthMetricsForCurrentMonthQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>> = ({ signal }) => getTagHealthGetTagHealthMetricsForCurrentMonth(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagHealthGetTagHealthMetricsForCurrentMonthQueryResult = NonNullable<Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>>
export type GetTagHealthGetTagHealthMetricsForCurrentMonthQueryError = unknown

export const useGetTagHealthGetTagHealthMetricsForCurrentMonth = <TData = Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>, TError = unknown>(
 params?: GetTagHealthGetTagHealthMetricsForCurrentMonthParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagHealthGetTagHealthMetricsForCurrentMonth>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagHealthGetTagHealthMetricsForCurrentMonthQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagHealthSearch = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagHealthMetricQueryResult>(
      {url: `/TagHealth/Search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagHealthSearchMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthSearch>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagHealthSearch>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagHealthSearch>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagHealthSearch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagHealthSearchMutationResult = NonNullable<Awaited<ReturnType<typeof postTagHealthSearch>>>
    export type PostTagHealthSearchMutationBody = Query
    export type PostTagHealthSearchMutationError = unknown

    export const usePostTagHealthSearch = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthSearch>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagHealthSearch>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagHealthSearchMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagHealthGetAvgScoreForQuery = (
    query: Query,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<number>(
      {url: `/TagHealth/GetAvgScoreForQuery`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: query
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagHealthGetAvgScoreForQueryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthGetAvgScoreForQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagHealthGetAvgScoreForQuery>>, TError,{data: Query}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagHealthGetAvgScoreForQuery>>, {data: Query}> = (props) => {
          const {data} = props ?? {};

          return  postTagHealthGetAvgScoreForQuery(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagHealthGetAvgScoreForQueryMutationResult = NonNullable<Awaited<ReturnType<typeof postTagHealthGetAvgScoreForQuery>>>
    export type PostTagHealthGetAvgScoreForQueryMutationBody = Query
    export type PostTagHealthGetAvgScoreForQueryMutationError = unknown

    export const usePostTagHealthGetAvgScoreForQuery = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthGetAvgScoreForQuery>>, TError,{data: Query}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagHealthGetAvgScoreForQuery>>,
        TError,
        {data: Query},
        TContext
      > => {

      const mutationOptions = getPostTagHealthGetAvgScoreForQueryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagHealthInsertFakeData = (
    params?: PostTagHealthInsertFakeDataParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagHealth/InsertFakeData`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagHealthInsertFakeDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthInsertFakeData>>, TError,{params?: PostTagHealthInsertFakeDataParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagHealthInsertFakeData>>, TError,{params?: PostTagHealthInsertFakeDataParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagHealthInsertFakeData>>, {params?: PostTagHealthInsertFakeDataParams}> = (props) => {
          const {params} = props ?? {};

          return  postTagHealthInsertFakeData(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagHealthInsertFakeDataMutationResult = NonNullable<Awaited<ReturnType<typeof postTagHealthInsertFakeData>>>
    
    export type PostTagHealthInsertFakeDataMutationError = unknown

    export const usePostTagHealthInsertFakeData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagHealthInsertFakeData>>, TError,{params?: PostTagHealthInsertFakeDataParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagHealthInsertFakeData>>,
        TError,
        {params?: PostTagHealthInsertFakeDataParams},
        TContext
      > => {

      const mutationOptions = getPostTagHealthInsertFakeDataMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putTagHistorySaveTagHistory = (
    tagHistoryItem: TagHistoryItem,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<StringSearchIndexChange[]>(
      {url: `/TagHistory/SaveTagHistory`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tagHistoryItem
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutTagHistorySaveTagHistoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagHistorySaveTagHistory>>, TError,{data: TagHistoryItem}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putTagHistorySaveTagHistory>>, TError,{data: TagHistoryItem}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTagHistorySaveTagHistory>>, {data: TagHistoryItem}> = (props) => {
          const {data} = props ?? {};

          return  putTagHistorySaveTagHistory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTagHistorySaveTagHistoryMutationResult = NonNullable<Awaited<ReturnType<typeof putTagHistorySaveTagHistory>>>
    export type PutTagHistorySaveTagHistoryMutationBody = TagHistoryItem
    export type PutTagHistorySaveTagHistoryMutationError = unknown

    export const usePutTagHistorySaveTagHistory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagHistorySaveTagHistory>>, TError,{data: TagHistoryItem}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putTagHistorySaveTagHistory>>,
        TError,
        {data: TagHistoryItem},
        TContext
      > => {

      const mutationOptions = getPutTagHistorySaveTagHistoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagManagerGetTagPolicies = (
    params?: GetTagManagerGetTagPoliciesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagPolicy[]>(
      {url: `/TagManager/GetTagPolicies`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagManagerGetTagPoliciesQueryKey = (params?: GetTagManagerGetTagPoliciesParams,) => {
    return [`/TagManager/GetTagPolicies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagManagerGetTagPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>, TError = unknown>(params?: GetTagManagerGetTagPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagManagerGetTagPoliciesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>> = ({ signal }) => getTagManagerGetTagPolicies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagManagerGetTagPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>>
export type GetTagManagerGetTagPoliciesQueryError = unknown

export const useGetTagManagerGetTagPolicies = <TData = Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>, TError = unknown>(
 params?: GetTagManagerGetTagPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetTagPolicies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagManagerGetTagPoliciesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagManagerGetTagPolicy = (
    params?: GetTagManagerGetTagPolicyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TagPolicy>(
      {url: `/TagManager/GetTagPolicy`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagManagerGetTagPolicyQueryKey = (params?: GetTagManagerGetTagPolicyParams,) => {
    return [`/TagManager/GetTagPolicy`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagManagerGetTagPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>, TError = unknown>(params?: GetTagManagerGetTagPolicyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagManagerGetTagPolicyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>> = ({ signal }) => getTagManagerGetTagPolicy(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagManagerGetTagPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>>
export type GetTagManagerGetTagPolicyQueryError = unknown

export const useGetTagManagerGetTagPolicy = <TData = Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>, TError = unknown>(
 params?: GetTagManagerGetTagPolicyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetTagPolicy>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagManagerGetTagPolicyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagManagerGetAWSTagPolicies = (
    params?: GetTagManagerGetAWSTagPoliciesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsPolicyDetailQueryResult>(
      {url: `/TagManager/GetAWSTagPolicies`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagManagerGetAWSTagPoliciesQueryKey = (params?: GetTagManagerGetAWSTagPoliciesParams,) => {
    return [`/TagManager/GetAWSTagPolicies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagManagerGetAWSTagPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>, TError = unknown>(params?: GetTagManagerGetAWSTagPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagManagerGetAWSTagPoliciesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>> = ({ signal }) => getTagManagerGetAWSTagPolicies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagManagerGetAWSTagPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>>
export type GetTagManagerGetAWSTagPoliciesQueryError = unknown

export const useGetTagManagerGetAWSTagPolicies = <TData = Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>, TError = unknown>(
 params?: GetTagManagerGetAWSTagPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetAWSTagPolicies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagManagerGetAWSTagPoliciesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagManagerImportAWSPolicies = (
    params?: PostTagManagerImportAWSPoliciesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PolicyGrouping[]>(
      {url: `/TagManager/ImportAWSPolicies`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagManagerImportAWSPoliciesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerImportAWSPolicies>>, TError,{params?: PostTagManagerImportAWSPoliciesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagManagerImportAWSPolicies>>, TError,{params?: PostTagManagerImportAWSPoliciesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagManagerImportAWSPolicies>>, {params?: PostTagManagerImportAWSPoliciesParams}> = (props) => {
          const {params} = props ?? {};

          return  postTagManagerImportAWSPolicies(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagManagerImportAWSPoliciesMutationResult = NonNullable<Awaited<ReturnType<typeof postTagManagerImportAWSPolicies>>>
    
    export type PostTagManagerImportAWSPoliciesMutationError = unknown

    export const usePostTagManagerImportAWSPolicies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerImportAWSPolicies>>, TError,{params?: PostTagManagerImportAWSPoliciesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagManagerImportAWSPolicies>>,
        TError,
        {params?: PostTagManagerImportAWSPoliciesParams},
        TContext
      > => {

      const mutationOptions = getPostTagManagerImportAWSPoliciesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTagManagerCreateTagPolicy = (
    tagPolicy: TagPolicy,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagPolicy>(
      {url: `/TagManager/CreateTagPolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tagPolicy
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagManagerCreateTagPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateTagPolicy>>, TError,{data: TagPolicy}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateTagPolicy>>, TError,{data: TagPolicy}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagManagerCreateTagPolicy>>, {data: TagPolicy}> = (props) => {
          const {data} = props ?? {};

          return  postTagManagerCreateTagPolicy(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagManagerCreateTagPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof postTagManagerCreateTagPolicy>>>
    export type PostTagManagerCreateTagPolicyMutationBody = TagPolicy
    export type PostTagManagerCreateTagPolicyMutationError = unknown

    export const usePostTagManagerCreateTagPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateTagPolicy>>, TError,{data: TagPolicy}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagManagerCreateTagPolicy>>,
        TError,
        {data: TagPolicy},
        TContext
      > => {

      const mutationOptions = getPostTagManagerCreateTagPolicyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putTagManagerSaveTagPolicy = (
    tagPolicy: TagPolicy,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<TagPolicy>(
      {url: `/TagManager/SaveTagPolicy`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tagPolicy
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutTagManagerSaveTagPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveTagPolicy>>, TError,{data: TagPolicy}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveTagPolicy>>, TError,{data: TagPolicy}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTagManagerSaveTagPolicy>>, {data: TagPolicy}> = (props) => {
          const {data} = props ?? {};

          return  putTagManagerSaveTagPolicy(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTagManagerSaveTagPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putTagManagerSaveTagPolicy>>>
    export type PutTagManagerSaveTagPolicyMutationBody = TagPolicy
    export type PutTagManagerSaveTagPolicyMutationError = unknown

    export const usePutTagManagerSaveTagPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveTagPolicy>>, TError,{data: TagPolicy}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putTagManagerSaveTagPolicy>>,
        TError,
        {data: TagPolicy},
        TContext
      > => {

      const mutationOptions = getPutTagManagerSaveTagPolicyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteTagManagerRemoveTagPolicy = (
    params?: DeleteTagManagerRemoveTagPolicyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagManager/RemoveTagPolicy`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteTagManagerRemoveTagPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveTagPolicy>>, TError,{params?: DeleteTagManagerRemoveTagPolicyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveTagPolicy>>, TError,{params?: DeleteTagManagerRemoveTagPolicyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTagManagerRemoveTagPolicy>>, {params?: DeleteTagManagerRemoveTagPolicyParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteTagManagerRemoveTagPolicy(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTagManagerRemoveTagPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTagManagerRemoveTagPolicy>>>
    
    export type DeleteTagManagerRemoveTagPolicyMutationError = unknown

    export const useDeleteTagManagerRemoveTagPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveTagPolicy>>, TError,{params?: DeleteTagManagerRemoveTagPolicyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteTagManagerRemoveTagPolicy>>,
        TError,
        {params?: DeleteTagManagerRemoveTagPolicyParams},
        TContext
      > => {

      const mutationOptions = getDeleteTagManagerRemoveTagPolicyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagManagerGetRestrictedTags = (
    params?: GetTagManagerGetRestrictedTagsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RestrictedTag[]>(
      {url: `/TagManager/GetRestrictedTags`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagManagerGetRestrictedTagsQueryKey = (params?: GetTagManagerGetRestrictedTagsParams,) => {
    return [`/TagManager/GetRestrictedTags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagManagerGetRestrictedTagsQueryOptions = <TData = Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>, TError = unknown>(params?: GetTagManagerGetRestrictedTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagManagerGetRestrictedTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>> = ({ signal }) => getTagManagerGetRestrictedTags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagManagerGetRestrictedTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>>
export type GetTagManagerGetRestrictedTagsQueryError = unknown

export const useGetTagManagerGetRestrictedTags = <TData = Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>, TError = unknown>(
 params?: GetTagManagerGetRestrictedTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetRestrictedTags>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagManagerGetRestrictedTagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getTagManagerGetRestrictedTag = (
    params?: GetTagManagerGetRestrictedTagParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RestrictedTag>(
      {url: `/TagManager/GetRestrictedTag`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagManagerGetRestrictedTagQueryKey = (params?: GetTagManagerGetRestrictedTagParams,) => {
    return [`/TagManager/GetRestrictedTag`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagManagerGetRestrictedTagQueryOptions = <TData = Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>, TError = unknown>(params?: GetTagManagerGetRestrictedTagParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagManagerGetRestrictedTagQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>> = ({ signal }) => getTagManagerGetRestrictedTag(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagManagerGetRestrictedTagQueryResult = NonNullable<Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>>
export type GetTagManagerGetRestrictedTagQueryError = unknown

export const useGetTagManagerGetRestrictedTag = <TData = Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>, TError = unknown>(
 params?: GetTagManagerGetRestrictedTagParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetRestrictedTag>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagManagerGetRestrictedTagQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagManagerCreateRestrictedTag = (
    restrictedTag: RestrictedTag,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RestrictedTag>(
      {url: `/TagManager/CreateRestrictedTag`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: restrictedTag
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagManagerCreateRestrictedTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateRestrictedTag>>, TError,{data: RestrictedTag}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateRestrictedTag>>, TError,{data: RestrictedTag}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagManagerCreateRestrictedTag>>, {data: RestrictedTag}> = (props) => {
          const {data} = props ?? {};

          return  postTagManagerCreateRestrictedTag(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagManagerCreateRestrictedTagMutationResult = NonNullable<Awaited<ReturnType<typeof postTagManagerCreateRestrictedTag>>>
    export type PostTagManagerCreateRestrictedTagMutationBody = RestrictedTag
    export type PostTagManagerCreateRestrictedTagMutationError = unknown

    export const usePostTagManagerCreateRestrictedTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateRestrictedTag>>, TError,{data: RestrictedTag}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagManagerCreateRestrictedTag>>,
        TError,
        {data: RestrictedTag},
        TContext
      > => {

      const mutationOptions = getPostTagManagerCreateRestrictedTagMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putTagManagerSaveRestrictedTag = (
    restrictedTag: RestrictedTag,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RestrictedTag>(
      {url: `/TagManager/SaveRestrictedTag`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: restrictedTag
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutTagManagerSaveRestrictedTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveRestrictedTag>>, TError,{data: RestrictedTag}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveRestrictedTag>>, TError,{data: RestrictedTag}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTagManagerSaveRestrictedTag>>, {data: RestrictedTag}> = (props) => {
          const {data} = props ?? {};

          return  putTagManagerSaveRestrictedTag(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTagManagerSaveRestrictedTagMutationResult = NonNullable<Awaited<ReturnType<typeof putTagManagerSaveRestrictedTag>>>
    export type PutTagManagerSaveRestrictedTagMutationBody = RestrictedTag
    export type PutTagManagerSaveRestrictedTagMutationError = unknown

    export const usePutTagManagerSaveRestrictedTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveRestrictedTag>>, TError,{data: RestrictedTag}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putTagManagerSaveRestrictedTag>>,
        TError,
        {data: RestrictedTag},
        TContext
      > => {

      const mutationOptions = getPutTagManagerSaveRestrictedTagMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteTagManagerRemoveRestrictedTag = (
    params?: DeleteTagManagerRemoveRestrictedTagParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagManager/RemoveRestrictedTag`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteTagManagerRemoveRestrictedTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveRestrictedTag>>, TError,{params?: DeleteTagManagerRemoveRestrictedTagParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveRestrictedTag>>, TError,{params?: DeleteTagManagerRemoveRestrictedTagParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTagManagerRemoveRestrictedTag>>, {params?: DeleteTagManagerRemoveRestrictedTagParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteTagManagerRemoveRestrictedTag(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTagManagerRemoveRestrictedTagMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTagManagerRemoveRestrictedTag>>>
    
    export type DeleteTagManagerRemoveRestrictedTagMutationError = unknown

    export const useDeleteTagManagerRemoveRestrictedTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveRestrictedTag>>, TError,{params?: DeleteTagManagerRemoveRestrictedTagParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteTagManagerRemoveRestrictedTag>>,
        TError,
        {params?: DeleteTagManagerRemoveRestrictedTagParams},
        TContext
      > => {

      const mutationOptions = getDeleteTagManagerRemoveRestrictedTagMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getTagManagerGetDraftPolicies = (
    params?: GetTagManagerGetDraftPoliciesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<PolicyGrouping[]>(
      {url: `/TagManager/GetDraftPolicies`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetTagManagerGetDraftPoliciesQueryKey = (params?: GetTagManagerGetDraftPoliciesParams,) => {
    return [`/TagManager/GetDraftPolicies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTagManagerGetDraftPoliciesQueryOptions = <TData = Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>, TError = unknown>(params?: GetTagManagerGetDraftPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTagManagerGetDraftPoliciesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>> = ({ signal }) => getTagManagerGetDraftPolicies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTagManagerGetDraftPoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>>
export type GetTagManagerGetDraftPoliciesQueryError = unknown

export const useGetTagManagerGetDraftPolicies = <TData = Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>, TError = unknown>(
 params?: GetTagManagerGetDraftPoliciesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTagManagerGetDraftPolicies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTagManagerGetDraftPoliciesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postTagManagerCreateDraftPolicy = (
    policyGrouping: PolicyGrouping,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PolicyGrouping>(
      {url: `/TagManager/CreateDraftPolicy`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: policyGrouping
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostTagManagerCreateDraftPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateDraftPolicy>>, TError,{data: PolicyGrouping}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateDraftPolicy>>, TError,{data: PolicyGrouping}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTagManagerCreateDraftPolicy>>, {data: PolicyGrouping}> = (props) => {
          const {data} = props ?? {};

          return  postTagManagerCreateDraftPolicy(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTagManagerCreateDraftPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof postTagManagerCreateDraftPolicy>>>
    export type PostTagManagerCreateDraftPolicyMutationBody = PolicyGrouping
    export type PostTagManagerCreateDraftPolicyMutationError = unknown

    export const usePostTagManagerCreateDraftPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTagManagerCreateDraftPolicy>>, TError,{data: PolicyGrouping}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTagManagerCreateDraftPolicy>>,
        TError,
        {data: PolicyGrouping},
        TContext
      > => {

      const mutationOptions = getPostTagManagerCreateDraftPolicyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putTagManagerSaveDraftPolicy = (
    policyGrouping: PolicyGrouping,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PolicyGrouping>(
      {url: `/TagManager/SaveDraftPolicy`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: policyGrouping
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutTagManagerSaveDraftPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveDraftPolicy>>, TError,{data: PolicyGrouping}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveDraftPolicy>>, TError,{data: PolicyGrouping}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTagManagerSaveDraftPolicy>>, {data: PolicyGrouping}> = (props) => {
          const {data} = props ?? {};

          return  putTagManagerSaveDraftPolicy(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTagManagerSaveDraftPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putTagManagerSaveDraftPolicy>>>
    export type PutTagManagerSaveDraftPolicyMutationBody = PolicyGrouping
    export type PutTagManagerSaveDraftPolicyMutationError = unknown

    export const usePutTagManagerSaveDraftPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTagManagerSaveDraftPolicy>>, TError,{data: PolicyGrouping}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putTagManagerSaveDraftPolicy>>,
        TError,
        {data: PolicyGrouping},
        TContext
      > => {

      const mutationOptions = getPutTagManagerSaveDraftPolicyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteTagManagerRemoveDraftPolicyGroup = (
    params?: DeleteTagManagerRemoveDraftPolicyGroupParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TagManager/RemoveDraftPolicyGroup`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteTagManagerRemoveDraftPolicyGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveDraftPolicyGroup>>, TError,{params?: DeleteTagManagerRemoveDraftPolicyGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveDraftPolicyGroup>>, TError,{params?: DeleteTagManagerRemoveDraftPolicyGroupParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTagManagerRemoveDraftPolicyGroup>>, {params?: DeleteTagManagerRemoveDraftPolicyGroupParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteTagManagerRemoveDraftPolicyGroup(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTagManagerRemoveDraftPolicyGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTagManagerRemoveDraftPolicyGroup>>>
    
    export type DeleteTagManagerRemoveDraftPolicyGroupMutationError = unknown

    export const useDeleteTagManagerRemoveDraftPolicyGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTagManagerRemoveDraftPolicyGroup>>, TError,{params?: DeleteTagManagerRemoveDraftPolicyGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteTagManagerRemoveDraftPolicyGroup>>,
        TError,
        {params?: DeleteTagManagerRemoveDraftPolicyGroupParams},
        TContext
      > => {

      const mutationOptions = getDeleteTagManagerRemoveDraftPolicyGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postVariantGroupGetAllTagsForAutocomplete = (
    params?: PostVariantGroupGetAllTagsForAutocompleteParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<string[]>(
      {url: `/VariantGroup/GetAllTagsForAutocomplete`, method: 'POST',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostVariantGroupGetAllTagsForAutocompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupGetAllTagsForAutocomplete>>, TError,{params?: PostVariantGroupGetAllTagsForAutocompleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupGetAllTagsForAutocomplete>>, TError,{params?: PostVariantGroupGetAllTagsForAutocompleteParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariantGroupGetAllTagsForAutocomplete>>, {params?: PostVariantGroupGetAllTagsForAutocompleteParams}> = (props) => {
          const {params} = props ?? {};

          return  postVariantGroupGetAllTagsForAutocomplete(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariantGroupGetAllTagsForAutocompleteMutationResult = NonNullable<Awaited<ReturnType<typeof postVariantGroupGetAllTagsForAutocomplete>>>
    
    export type PostVariantGroupGetAllTagsForAutocompleteMutationError = unknown

    export const usePostVariantGroupGetAllTagsForAutocomplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupGetAllTagsForAutocomplete>>, TError,{params?: PostVariantGroupGetAllTagsForAutocompleteParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postVariantGroupGetAllTagsForAutocomplete>>,
        TError,
        {params?: PostVariantGroupGetAllTagsForAutocompleteParams},
        TContext
      > => {

      const mutationOptions = getPostVariantGroupGetAllTagsForAutocompleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getVariantGroupGetVariantGroups = (
    params?: GetVariantGroupGetVariantGroupsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<VariantGroup[]>(
      {url: `/VariantGroup/GetVariantGroups`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetVariantGroupGetVariantGroupsQueryKey = (params?: GetVariantGroupGetVariantGroupsParams,) => {
    return [`/VariantGroup/GetVariantGroups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVariantGroupGetVariantGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>, TError = unknown>(params?: GetVariantGroupGetVariantGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantGroupGetVariantGroupsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>> = ({ signal }) => getVariantGroupGetVariantGroups(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariantGroupGetVariantGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>>
export type GetVariantGroupGetVariantGroupsQueryError = unknown

export const useGetVariantGroupGetVariantGroups = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>, TError = unknown>(
 params?: GetVariantGroupGetVariantGroupsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantGroups>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetVariantGroupGetVariantGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVariantGroupGetVariantGroup = (
    params?: GetVariantGroupGetVariantGroupParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<VariantGroup>(
      {url: `/VariantGroup/GetVariantGroup`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetVariantGroupGetVariantGroupQueryKey = (params?: GetVariantGroupGetVariantGroupParams,) => {
    return [`/VariantGroup/GetVariantGroup`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVariantGroupGetVariantGroupQueryOptions = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>, TError = unknown>(params?: GetVariantGroupGetVariantGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantGroupGetVariantGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>> = ({ signal }) => getVariantGroupGetVariantGroup(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariantGroupGetVariantGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>>
export type GetVariantGroupGetVariantGroupQueryError = unknown

export const useGetVariantGroupGetVariantGroup = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>, TError = unknown>(
 params?: GetVariantGroupGetVariantGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantGroup>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetVariantGroupGetVariantGroupQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVariantGroupGetVariantsForGroup = (
    params?: GetVariantGroupGetVariantsForGroupParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Variant[]>(
      {url: `/VariantGroup/GetVariantsForGroup`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetVariantGroupGetVariantsForGroupQueryKey = (params?: GetVariantGroupGetVariantsForGroupParams,) => {
    return [`/VariantGroup/GetVariantsForGroup`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVariantGroupGetVariantsForGroupQueryOptions = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>, TError = unknown>(params?: GetVariantGroupGetVariantsForGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantGroupGetVariantsForGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>> = ({ signal }) => getVariantGroupGetVariantsForGroup(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariantGroupGetVariantsForGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>>
export type GetVariantGroupGetVariantsForGroupQueryError = unknown

export const useGetVariantGroupGetVariantsForGroup = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>, TError = unknown>(
 params?: GetVariantGroupGetVariantsForGroupParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariantsForGroup>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetVariantGroupGetVariantsForGroupQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getVariantGroupGetVariant = (
    params?: GetVariantGroupGetVariantParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Variant>(
      {url: `/VariantGroup/GetVariant`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetVariantGroupGetVariantQueryKey = (params?: GetVariantGroupGetVariantParams,) => {
    return [`/VariantGroup/GetVariant`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVariantGroupGetVariantQueryOptions = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariant>>, TError = unknown>(params?: GetVariantGroupGetVariantParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariant>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantGroupGetVariantQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantGroupGetVariant>>> = ({ signal }) => getVariantGroupGetVariant(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariant>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariantGroupGetVariantQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantGroupGetVariant>>>
export type GetVariantGroupGetVariantQueryError = unknown

export const useGetVariantGroupGetVariant = <TData = Awaited<ReturnType<typeof getVariantGroupGetVariant>>, TError = unknown>(
 params?: GetVariantGroupGetVariantParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariantGroupGetVariant>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetVariantGroupGetVariantQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postVariantGroupCreateVariantGroup = (
    variantGroup: VariantGroup,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<VariantGroup>(
      {url: `/VariantGroup/CreateVariantGroup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: variantGroup
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostVariantGroupCreateVariantGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupCreateVariantGroup>>, TError,{data: VariantGroup}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupCreateVariantGroup>>, TError,{data: VariantGroup}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariantGroupCreateVariantGroup>>, {data: VariantGroup}> = (props) => {
          const {data} = props ?? {};

          return  postVariantGroupCreateVariantGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariantGroupCreateVariantGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postVariantGroupCreateVariantGroup>>>
    export type PostVariantGroupCreateVariantGroupMutationBody = VariantGroup
    export type PostVariantGroupCreateVariantGroupMutationError = unknown

    export const usePostVariantGroupCreateVariantGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupCreateVariantGroup>>, TError,{data: VariantGroup}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postVariantGroupCreateVariantGroup>>,
        TError,
        {data: VariantGroup},
        TContext
      > => {

      const mutationOptions = getPostVariantGroupCreateVariantGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postVariantGroupAddVariantsToVariantGroup = (
    variant: Variant[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<VariantGroup>(
      {url: `/VariantGroup/AddVariantsToVariantGroup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: variant
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostVariantGroupAddVariantsToVariantGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupAddVariantsToVariantGroup>>, TError,{data: Variant[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupAddVariantsToVariantGroup>>, TError,{data: Variant[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariantGroupAddVariantsToVariantGroup>>, {data: Variant[]}> = (props) => {
          const {data} = props ?? {};

          return  postVariantGroupAddVariantsToVariantGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariantGroupAddVariantsToVariantGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postVariantGroupAddVariantsToVariantGroup>>>
    export type PostVariantGroupAddVariantsToVariantGroupMutationBody = Variant[]
    export type PostVariantGroupAddVariantsToVariantGroupMutationError = unknown

    export const usePostVariantGroupAddVariantsToVariantGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupAddVariantsToVariantGroup>>, TError,{data: Variant[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postVariantGroupAddVariantsToVariantGroup>>,
        TError,
        {data: Variant[]},
        TContext
      > => {

      const mutationOptions = getPostVariantGroupAddVariantsToVariantGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postVariantGroupConsolidateVariantGroup = (
    variantResource: VariantResource[],
    params?: PostVariantGroupConsolidateVariantGroupParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/VariantGroup/ConsolidateVariantGroup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: variantResource,
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPostVariantGroupConsolidateVariantGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupConsolidateVariantGroup>>, TError,{data: VariantResource[];params?: PostVariantGroupConsolidateVariantGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupConsolidateVariantGroup>>, TError,{data: VariantResource[];params?: PostVariantGroupConsolidateVariantGroupParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariantGroupConsolidateVariantGroup>>, {data: VariantResource[];params?: PostVariantGroupConsolidateVariantGroupParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postVariantGroupConsolidateVariantGroup(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariantGroupConsolidateVariantGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postVariantGroupConsolidateVariantGroup>>>
    export type PostVariantGroupConsolidateVariantGroupMutationBody = VariantResource[]
    export type PostVariantGroupConsolidateVariantGroupMutationError = unknown

    export const usePostVariantGroupConsolidateVariantGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantGroupConsolidateVariantGroup>>, TError,{data: VariantResource[];params?: PostVariantGroupConsolidateVariantGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postVariantGroupConsolidateVariantGroup>>,
        TError,
        {data: VariantResource[];params?: PostVariantGroupConsolidateVariantGroupParams},
        TContext
      > => {

      const mutationOptions = getPostVariantGroupConsolidateVariantGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putVariantGroupUpdateVariantGroup = (
    variantGroup: VariantGroup,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<VariantGroup>(
      {url: `/VariantGroup/UpdateVariantGroup`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: variantGroup
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutVariantGroupUpdateVariantGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVariantGroupUpdateVariantGroup>>, TError,{data: VariantGroup}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putVariantGroupUpdateVariantGroup>>, TError,{data: VariantGroup}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVariantGroupUpdateVariantGroup>>, {data: VariantGroup}> = (props) => {
          const {data} = props ?? {};

          return  putVariantGroupUpdateVariantGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVariantGroupUpdateVariantGroupMutationResult = NonNullable<Awaited<ReturnType<typeof putVariantGroupUpdateVariantGroup>>>
    export type PutVariantGroupUpdateVariantGroupMutationBody = VariantGroup
    export type PutVariantGroupUpdateVariantGroupMutationError = unknown

    export const usePutVariantGroupUpdateVariantGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVariantGroupUpdateVariantGroup>>, TError,{data: VariantGroup}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putVariantGroupUpdateVariantGroup>>,
        TError,
        {data: VariantGroup},
        TContext
      > => {

      const mutationOptions = getPutVariantGroupUpdateVariantGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putVariantGroupUpdateVariantResources = (
    variant: Variant[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/VariantGroup/UpdateVariantResources`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: variant
    },
      { type: 'TagManager',  ...options});
    }
  


export const getPutVariantGroupUpdateVariantResourcesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVariantGroupUpdateVariantResources>>, TError,{data: Variant[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putVariantGroupUpdateVariantResources>>, TError,{data: Variant[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVariantGroupUpdateVariantResources>>, {data: Variant[]}> = (props) => {
          const {data} = props ?? {};

          return  putVariantGroupUpdateVariantResources(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVariantGroupUpdateVariantResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof putVariantGroupUpdateVariantResources>>>
    export type PutVariantGroupUpdateVariantResourcesMutationBody = Variant[]
    export type PutVariantGroupUpdateVariantResourcesMutationError = unknown

    export const usePutVariantGroupUpdateVariantResources = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVariantGroupUpdateVariantResources>>, TError,{data: Variant[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putVariantGroupUpdateVariantResources>>,
        TError,
        {data: Variant[]},
        TContext
      > => {

      const mutationOptions = getPutVariantGroupUpdateVariantResourcesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteVariantGroupDeleteVariant = (
    params?: DeleteVariantGroupDeleteVariantParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/VariantGroup/DeleteVariant`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteVariantGroupDeleteVariantMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariant>>, TError,{params?: DeleteVariantGroupDeleteVariantParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariant>>, TError,{params?: DeleteVariantGroupDeleteVariantParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariant>>, {params?: DeleteVariantGroupDeleteVariantParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteVariantGroupDeleteVariant(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVariantGroupDeleteVariantMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariant>>>
    
    export type DeleteVariantGroupDeleteVariantMutationError = unknown

    export const useDeleteVariantGroupDeleteVariant = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariant>>, TError,{params?: DeleteVariantGroupDeleteVariantParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteVariantGroupDeleteVariant>>,
        TError,
        {params?: DeleteVariantGroupDeleteVariantParams},
        TContext
      > => {

      const mutationOptions = getDeleteVariantGroupDeleteVariantMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteVariantGroupDeleteVariantGroup = (
    params?: DeleteVariantGroupDeleteVariantGroupParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/VariantGroup/DeleteVariantGroup`, method: 'DELETE',
        params
    },
      { type: 'TagManager',  ...options});
    }
  


export const getDeleteVariantGroupDeleteVariantGroupMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariantGroup>>, TError,{params?: DeleteVariantGroupDeleteVariantGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariantGroup>>, TError,{params?: DeleteVariantGroupDeleteVariantGroupParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariantGroup>>, {params?: DeleteVariantGroupDeleteVariantGroupParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteVariantGroupDeleteVariantGroup(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVariantGroupDeleteVariantGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariantGroup>>>
    
    export type DeleteVariantGroupDeleteVariantGroupMutationError = unknown

    export const useDeleteVariantGroupDeleteVariantGroup = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantGroupDeleteVariantGroup>>, TError,{params?: DeleteVariantGroupDeleteVariantGroupParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteVariantGroupDeleteVariantGroup>>,
        TError,
        {params?: DeleteVariantGroupDeleteVariantGroupParams},
        TContext
      > => {

      const mutationOptions = getDeleteVariantGroupDeleteVariantGroupMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getVariationDetectorCalculateLevensteinDistance = (
    params?: GetVariationDetectorCalculateLevensteinDistanceParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number>(
      {url: `/VariationDetector/CalculateLevensteinDistance`, method: 'GET',
        params, signal
    },
      { type: 'TagManager',  ...options});
    }
  

export const getGetVariationDetectorCalculateLevensteinDistanceQueryKey = (params?: GetVariationDetectorCalculateLevensteinDistanceParams,) => {
    return [`/VariationDetector/CalculateLevensteinDistance`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVariationDetectorCalculateLevensteinDistanceQueryOptions = <TData = Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>, TError = unknown>(params?: GetVariationDetectorCalculateLevensteinDistanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariationDetectorCalculateLevensteinDistanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>> = ({ signal }) => getVariationDetectorCalculateLevensteinDistance(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetVariationDetectorCalculateLevensteinDistanceQueryResult = NonNullable<Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>>
export type GetVariationDetectorCalculateLevensteinDistanceQueryError = unknown

export const useGetVariationDetectorCalculateLevensteinDistance = <TData = Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>, TError = unknown>(
 params?: GetVariationDetectorCalculateLevensteinDistanceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getVariationDetectorCalculateLevensteinDistance>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetVariationDetectorCalculateLevensteinDistanceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




